@if (showLayout) {
  <app-base-sidebar>
    <router-outlet />
  </app-base-sidebar>
} @else {
  <router-outlet />
}
